const fields = ["source", "medium", "campaign", "content"];
const slug = /^[a-z0-9][a-z0-9_-]{0,63}$/;
export function cleanCampaign(value = {}) {
  return Object.fromEntries(fields.filter((key) => typeof value[key] === "string" && slug.test(value[key])).map((key) => [key, value[key]]));
}
const params = new URLSearchParams(window.location.search);
const arrival = cleanCampaign(Object.fromEntries(fields.map((key) => [key, params.get(`utm_${key}`)])));
export function arrivalCampaign() { return { ...arrival }; }
